import { Injectable } from '@angular/core';
// import { IModulo } from 'app/store/reducers/permisos.reducers';

@Injectable()
export class FuncionesGlobales {
    constructor() {}
    
    public static GetRecursividad(data: any[]) {
        let modulos: any[] = [];
        try {
            data.forEach((currentNode) => {
                if (!currentNode.cnf_modulo) {
                    const existingParentIndex = modulos.findIndex(
                        (x) => x.id === currentNode.id
                    );

                    if (existingParentIndex === -1) {
                        modulos.push({
                            children: [],
                            father: currentNode.cnf_modulo,
                            caption: currentNode.caption,
                            name: currentNode.nombre,
                            title: currentNode.nombre,
                            type: 'collapsable',
                            key: currentNode.clave,
                            id: currentNode.id,
                            icon: '',
                            link: currentNode.caption.router,
                        });
                    }
                } else {
                    const parentIndex = modulos.findIndex(
                        (x) => x.id === currentNode.cnf_modulo.id
                    );

                    if (parentIndex > -1) {
                        // Encontramos el nodo padre
                        const newNode = {
                            father: currentNode.cnf_modulo,
                            caption: currentNode.caption,
                            name: currentNode.nombre,
                            title: currentNode.nombre,
                            type: 'basic',
                            key: currentNode.clave,
                            id: currentNode.id,
                            icon: '',
                            link: currentNode.caption.router,
                        };

                        modulos[parentIndex].children.push(newNode);
                    }
                }
            });

            //console.log("***modulos", modulos);
            return modulos;
        } catch (error) {
            console.log('recursividad error', error);
        }
    }
}
